import React from 'react';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';

const ProjectReportExport = ({ data, fileName, billableTime, nonBillableTime }) => {
    const headers = [
        'S.No', 'Channel', 'Client', 'Billing Type', 'Meter', 'Project', 'Employee', 'Department', 'Total Hours', 'Bill Hours', 
        'Bill Description', 'Non-Bill Hours', 'Non-Bill Description', 'Date', 'TL Assigned'
    ];


    // Function to map data to headers
    const mapDataToHeaders = (data) => {        
        return data.map((item, index) => {
            return {
                'S.No'                  : index + 1,
                'Channel'               : item.channel || '-',
                'Client'                : item.client || '-',
                'Billing Type'          : item.billing_type || '-',
                'Meter'                 : item.meter || '-',
                'Project'               : item.project || '-',
                'Employee'              : item.user_name || '-',
                'Department'            : item.department || '-',
                'Total Hours'           : item.time_spend || '-',
                'Bill Hours'            : item.billable_time || '-',
                'Bill Description'      : item.billable_description || '-',
                'Non-Bill Hours'        : item.nonbillable_time || '-',
                'Non-Bill Description'  : item.nonbillable_description || '-',
                'Date'                  : item.time_log_date.split(' ')[0] || '-',
                'TL Assigned'           : item.assignedTLName || '-',
            };
        });
    };


    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(`${fileName}`);

        // To apply border style
        const applyBorder = (cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        };

        // Define color and pattern for header
        const headerColor = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '8ea5e8' }
        };

        // Add header row with styling
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { size: 10, bold: true };
        headerRow.alignment = { horizontal: 'center' };
        headerRow.height = 30;

        // Apply header color to columns A-0
        for (let i = 1; i <= 15; i++) {
            const cell = worksheet.getCell(1, i);
            cell.fill = headerColor;
            applyBorder(cell);
        }

        if (data.length === 0) {
            worksheet.mergeCells('A2:O2');
            const cell = worksheet.getCell('A2');
            cell.value = 'No record found';
            cell.alignment = { horizontal: 'center' };
            applyBorder(cell);
        } 
        else {
            const mappedData = mapDataToHeaders(data);
            mappedData.forEach(row => {
                const excelRow = worksheet.addRow(headers.map(header => row[header]));
                excelRow.eachCell({ includeEmpty: true }, cell => {
                    applyBorder(cell);
                });
            });

            // Add Total Hours Row
            const totalRow = worksheet.addRow(['','','','','','','','Total Hours',
                                                (billableTime+nonBillableTime).toFixed(2),
                                                billableTime.toFixed(2),
                                                '',
                                                nonBillableTime.toFixed(2),
                                                '','','']);
            totalRow.font = { bold: true };
            totalRow.eachCell({ includeEmpty: true }, cell => {
                applyBorder(cell);
            });
        }

        // Auto adjust column widths
        worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, cell => {
                if (cell.value && cell.value.toString().length > maxLength) {
                    maxLength = cell.value.toString().length;
                }
            });
            column.width = maxLength + 2;
        });

        // Set specific column 'K & M' width and wrap text
        const billDescColumnIndex = 11;
        worksheet.getColumn(billDescColumnIndex).width = 50;
        worksheet.getColumn(billDescColumnIndex).eachCell({ includeEmpty: true }, cell => {
            cell.alignment = { wrapText: true };
        });
        const nonBillDescColumnIndex = 13;
        worksheet.getColumn(nonBillDescColumnIndex).width = 50;
        worksheet.getColumn(nonBillDescColumnIndex).eachCell({ includeEmpty: true }, cell => {
            cell.alignment = { wrapText: true };
        });

        // Save the workbook
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        saveAs(blob, `${fileName}.xlsx`);
    };

    return (
        <button className="btn btn-primary" onClick={exportToExcel}>
            <i className="fa fa-file-excel"></i> &nbsp; Export to Excel</button>
    );
}

export default ProjectReportExport;
